import { HelpHint } from "@/components/ui/help-hint";
import { useTranslate } from "ra-core";
import type { ReactNode } from "react";

import { FormDescription } from "@/components/admin/form";

/**
 * Renders helper text below form inputs with automatic translation support.
 *
 * @internal
 */
export function InputHelperText({ helperText }: { helperText?: ReactNode }) {
  const translate = useTranslate();

  if (!helperText) {
    return null;
  }

  return (
    <FormDescription>
      <HelpHint>
        {typeof helperText === "string"
          ? translate(helperText, { _: helperText })
          : helperText}
      </HelpHint>
    </FormDescription>
  );
}
